/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Sex_FemaleInputs */

const en_us2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const pt_br2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const es_419_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femenino`)
};

const pt_pt2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const fr_fr2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Féminin`)
};

const de_de2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiblich`)
};

const it_it2_onboarding_sex_female = /** @type {(inputs: Onboarding_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femminile`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {Onboarding_Sex_FemaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_sex_female = /** @type {((inputs?: Onboarding_Sex_FemaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Sex_FemaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_sex_female(inputs)
	if (locale === "es-419") return es_419_onboarding_sex_female(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_sex_female(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_sex_female(inputs)
	if (locale === "de-DE") return de_de2_onboarding_sex_female(inputs)
	if (locale === "it-IT") return it_it2_onboarding_sex_female(inputs)
	return en_us2_onboarding_sex_female(inputs)
});
export { onboarding_sex_female as "onboarding.sex.female" }